import React, { useState } from 'react'
import { Box, Button, Card, TextField, Typography, makeStyles } from '@material-ui/core'
import { FlexHorizontal, Spacer, useToasts } from '@vestaboard/installables'
import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateServiceAuthToken {
    serviceJWT: createServiceAuthTokenV2 {
      ... on AuthTokenV2 {
        token
      }
      ... on AuthTokenErrorV2 {
        type
        error
      }
    }
  }
`

const useStyles = makeStyles({
  box: {
    padding: 24
  },
  tokenField: {
    width: '100%',
    fontFamily: 'monospace'
  }
})

export const ServiceJwt = () => {
  const classes = useStyles()
  const { addToast } = useToasts()
  const [token, setToken] = useState<string | null>(null)
  const [createServiceAuthToken, { loading }] = useMutation(MUTATION)

  const handleGenerate = async () => {
    try {
      const result = await createServiceAuthToken()
      const data = result?.data?.serviceJWT

      if (data?.__typename === 'AuthTokenErrorV2') {
        addToast(data.error || 'Failed to generate token', { appearance: 'error' })
        return
      }

      if (data?.token) {
        setToken(data.token)
      }
    } catch (e) {
      addToast('Failed to generate token', { appearance: 'error' })
    }
  }

  const handleCopy = () => {
    if (token) {
      navigator.clipboard.writeText(token)
      addToast('Token copied to clipboard', { appearance: 'success' })
    }
  }

  return (
    <>
      <Typography variant='h4'>Service JWT</Typography>
      <Spacer size='extraLarge' />
      <Card>
        <Box className={classes.box}>
          <Typography variant='h5'>Generate a Service-to-Service JWT</Typography>
          <Spacer size='medium' />
          <FlexHorizontal>
            <Button variant='contained' color='primary' onClick={handleGenerate} disabled={loading}>
              {loading ? 'Generating...' : 'Generate Token'}
            </Button>
            {token ? (
              <>
                <Spacer size='medium' />
                <Button variant='outlined' onClick={handleCopy}>
                  Copy to Clipboard
                </Button>
              </>
            ) : null}
          </FlexHorizontal>
          {token ? (
            <>
              <Spacer size='large' />
              <TextField
                className={classes.tokenField}
                multiline
                rows={4}
                value={token}
                variant='outlined'
                InputProps={{ readOnly: true }}
              />
            </>
          ) : null}
        </Box>
      </Card>
    </>
  )
}
